export default __webpack_public_path__ + "static/media/jugpuzzle.10c607e0.png";